import api from '../config/api';
import { Raffle, CreateRaffleData, PaginatedResponse, Draw } from '../types';

export const raffleService = {
  // Get public raffles
  getPublicRaffles: async (params?: { page?: number; limit?: number; countryCode?: string }): Promise<PaginatedResponse<Raffle>> => {
    const response = await api.get('/raffles/public', { params });
    return response.data;
  },

  // Get user's raffles
  getMyRaffles: async (params?: { page?: number; limit?: number; status?: string }): Promise<PaginatedResponse<Raffle>> => {
    const response = await api.get('/raffles/my-raffles', { params });
    return response.data;
  },

  // Get raffle by ID
  getRaffleById: async (id: string): Promise<{ success: boolean; data: Raffle }> => {
    const response = await api.get(`/raffles/${id}`);
    return response.data;
  },

  // Create raffle
  createRaffle: async (data: CreateRaffleData): Promise<{ success: boolean; data: Raffle }> => {
    const response = await api.post('/raffles/', data);
    return response.data;
  },

  // Update raffle
  updateRaffle: async (id: string, data: Partial<CreateRaffleData>): Promise<{ success: boolean; data: Raffle }> => {
    const response = await api.put(`/raffles/${id}`, data);
    return response.data;
  },

  // Delete raffle
  deleteRaffle: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/raffles/${id}`);
    return response.data;
  },

  // Close raffle
  closeRaffle: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/raffles/${id}/close`);
    return response.data;
  },

  // Pause raffle
  pauseRaffle: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/raffles/${id}/pause`);
    return response.data;
  },

  // Get raffle draws
  getRaffleDraws: async (
    raffleId: string,
    params?: {
      page?: number;
      limit?: number;
      startDate?: string;
      endDate?: string;
      sortBy?: string;
      sortOrder?: 'asc' | 'desc';
    }
  ): Promise<PaginatedResponse<Draw>> => {
    const response = await api.get(`/raffles/${raffleId}/draws`, { params });
    return response.data;
  },

  // Get public raffle draws (no auth required)
  getPublicRaffleDraws: async (
    raffleId: string,
    params?: {
      page?: number;
      limit?: number;
      drawDate?: string;
    }
  ): Promise<{ success: boolean; data: { raffle: { id: string; name: string; currency: string }; draws: Draw[]; pagination: any } }> => {
    const response = await api.get(`/raffles/${raffleId}/draws/public`, { params });
    return response.data;
  },
};
